export enum OpponentUserType {
	REAL_USER = "REAL_USER",
	BOT = "BOT",
}

export enum OpponentRelationUserType {
	RANDOM_USER = "random_user",
	FRIEND = "friend",
}

export enum ChallengeResult {
	NONE = "none",
	WIN = "win",
	LOSS = "loss",
	DRAW = "draw",
}

export enum ChallengeStatus {
	NOT_ACCEPTED = "not_accepted",
	PENDING = "pending",
	ACCEPTED = "accepted",
}

export enum ChallengeSource {
	SEARCH = "search",
}

export enum PoolStatus {
	OPEN = "open",
	CLOSED = "closed",
	PROCESSED = "processed",
}

export enum ChallengeRosterStatus {
	SCHEDULED = "scheduled",
	PLAYING = "playing",
	COMPLETE = "complete",
}

export enum ChallengeViewType {
	FULL = "full",
	H2H = "h2h",
}

export enum ChallengeRosterSource {
	YOU = "YOU",
	OPPONENT = "OPPONENT",
}
